import { Box, Typography } from '@mui/material';
import { TYPE } from '@/theme/typography';

export function InfoRow({ label, value }: { label: string; value: string | null | undefined }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.75, borderBottom: '1px solid', borderColor: 'divider' }}>
      <Typography sx={{ fontSize: TYPE.md, color: 'text.secondary' }}>{label}</Typography>
      <Typography sx={{ fontSize: TYPE.md, fontWeight: TYPE.medium }}>{value || '—'}</Typography>
    </Box>
  );
}

export function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <Typography sx={{ fontSize: TYPE.sm, fontWeight: TYPE.bold, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.06em', mb: 1, mt: 2 }}>
      {children}
    </Typography>
  );
}
